export default "/images/vendor/flag-icons/flags/4x3/gg.svg?b8779f1806c259de289ac4b3919fd732";